import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GlobalConstants, WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';
import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

import { WebAPIService } from 'src/app/services/webapi/web-api.service';

import { IPromocion } from 'src/app/interfaces/IPromocion';

@Injectable({
  providedIn: 'root'
})
export class PromocionService {

//#region Properties

  public AllPromociones: Array<IPromocion> = [];
  public AllImagenes: Array<IPromocion> = [];

  public CurrentPromocion: IPromocion;

//#endregion Properties

//#region Constructor

  constructor(private _webAPISrv: WebAPIService,
              private _deviceInfoSrv: DeviceInfoService,
              private _globalFunctionsSrv: GlobalFunctionsService) {

  }

//#endregion Constructor

//#region Promociones Get

  public getAllPromocionesWeb(): Observable<void> {

    console.log('-------------------------------------------');
    console.log('PromocionService >> getAllPromocionesWeb');

    const idSucursal: string = '001'; // Default sucursal san isidro

    const url: string = WebAPIConstants.URLPromocionPoS + 'getAllPromocionesWeb/' + idSucursal;
    const deviceUUID: string = this._deviceInfoSrv.CurrentDeviceInfo.DeviceUUID;
    const token: string = this._deviceInfoSrv.CurrentDeviceInfo.Token;

    return this._webAPISrv.get(url, deviceUUID, token, true).pipe(map((allPromociones: Array<IPromocion>) => {
      this.AllPromociones = allPromociones;

      console.log('-------------------------------------------');
      console.log('allPromociones: ' + allPromociones.length);
      console.log('-------------------------------------------');
    }));

  }

//#endregion Promociones Get

}
